import React from 'react';
import { Button } from './button';
import { cn } from '@/lib/utils';

interface SessionEndButtonProps {
  onClick: () => void;
  className?: string;
  variant?: 'default' | 'compact' | 'ghost';
}

/**
 * A styled button for ending a coaching session
 */
export function SessionEndButton({
  onClick,
  className,
  variant = 'default',
}: SessionEndButtonProps) {
  // Styling based on variant
  const buttonStyles = {
    default: 'bg-red-500 hover:bg-red-600 text-white',
    compact: 'bg-red-500 hover:bg-red-600 text-white text-sm px-3 py-1',
    ghost: 'bg-transparent hover:bg-red-100 text-red-500 border border-red-500',
  };

  return (
    <Button
      className={cn(
        'font-medium transition-colors',
        buttonStyles[variant],
        className
      )}
      onClick={onClick}
    >
      End Session
    </Button>
  );
}